import Vue from 'vue'
import VueI18n from 'vue-i18n' // 引入国际化插件包
import Cookies from 'js-cookie'
import locale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui 英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui 中文包
import elementZhTwLocale from 'element-ui/lib/locale/lang/zh-TW'
import elementIdIDLocale from 'element-ui/lib/locale/lang/id'
import customEN from './en.json'  // 自定义英语包
import customZH from './cn.json'  // 自定义中文包
import customIdID from './id.json'  // 自定义印尼包
import customZhTw from './tw.json'  // 自定义中文繁体

Vue.use(VueI18n) // 全局注册国际化包

const messages = {
  'en-US': {
    ...customEN,
    ...elementEnLocale
  },
  'zh-CN': {
    ...customZH ,
    ...elementZhLocale
  },
  'zh-TW': {
    ...customZhTw ,
    ...elementZhTwLocale
  },
  'id-ID': {
    ...customIdID ,
    ...elementIdIDLocale
  }
}
export function getLanguage() {
  const chooseLanguage = Cookies.get('flowinnIotLanguage')
  console.info("chooseLanguage:"+chooseLanguage)
  if (chooseLanguage) return chooseLanguage

  // 如果没有选择语言
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh-CN' // 默认语言
}
const i18n = new VueI18n({
  locale: getLanguage(),
  messages
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js